import React from 'react';
import {
    FormField,
    Select,
    SelectProps,
} from '@amzn/awsui-components-react-v3';

import { ActivityData } from '../../../../interfaces/activity';

export const CUSTOMER_LMS_PLATFORM_DESCRIPTION =
    'The platform used for the customer LMS.';

interface CustomerLMSPlatformOption extends SelectProps.Option {
    readonly label: string;
    readonly value: string;
}

const customerLMSPlatformOptions: Array<CustomerLMSPlatformOption> = [
    {
        label: 'RingCentral',
        value: 'RingCentral',
    },
    {
        label: 'Other',
        value: 'Other',
    },
];

const customerLMSPlatformOptionsLookup = customerLMSPlatformOptions.reduce(
    (acc, opt) => {
        acc[opt.label] = opt;
        return acc;
    },
    {} as {
        [key: string]: CustomerLMSPlatformOption;
    },
);

interface CustomerLMSPlatformSelectProps {
    handleFieldEvent: (values: Partial<ActivityData>) => void;
    formValues: {
        customer_lms_platform?: string;
    };
    errors?: {
        customer_lms_platform?: string;
    };
}

const CustomerLMSPlatformSelect = ({
    handleFieldEvent,
    formValues,
    errors,
}: CustomerLMSPlatformSelectProps) => {
    return (
        <FormField
            label={<span>CustomerLMS Platform</span>}
            description={CUSTOMER_LMS_PLATFORM_DESCRIPTION}
            errorText={errors?.customer_lms_platform}
            data-testid="formField-EditCustomerLMSPlatform"
        >
            <Select
                placeholder="Select CustomerLMS Platform"
                options={customerLMSPlatformOptions}
                selectedOption={
                    formValues.customer_lms_platform
                        ? customerLMSPlatformOptionsLookup[
                              formValues.customer_lms_platform
                          ]
                        : null
                }
                onChange={(e) => {
                    handleFieldEvent({
                        customer_lms_platform: e.detail.selectedOption.label,
                    });
                }}
                data-testid="EditCustomerLMSPlatform"
            />
        </FormField>
    );
};

export default CustomerLMSPlatformSelect;
